export enum ApiServerType {
  MT4 = 'MT4',
  MT5 = 'MT5',
  cTrader = 'cTrader',
  FixTaker = 'FIX_TAKER',
}
